/**
 * @generated SignedSource<<5900d9340a3c81ba9af9339fb0cbaa77>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rosterLoadId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "uploadSuccessful"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RosterLoadMutationGroup",
    "kind": "LinkedField",
    "name": "rosterLoad",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "rosterLoadId",
                "variableName": "rosterLoadId"
              },
              {
                "kind": "Variable",
                "name": "uploadSuccessful",
                "variableName": "uploadSuccessful"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "RosterLoadModifyPayload",
        "kind": "LinkedField",
        "name": "reportRosterUploadStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RosterLoad",
            "kind": "LinkedField",
            "name": "rosterLoad",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NewRosterLoadModalReportStatusMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NewRosterLoadModalReportStatusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "63b1ce3795293d44d5ee7699a165e033",
    "id": null,
    "metadata": {},
    "name": "NewRosterLoadModalReportStatusMutation",
    "operationKind": "mutation",
    "text": "mutation NewRosterLoadModalReportStatusMutation(\n  $rosterLoadId: ID!\n  $uploadSuccessful: Boolean!\n) {\n  rosterLoad {\n    reportRosterUploadStatus(input: {rosterLoadId: $rosterLoadId, uploadSuccessful: $uploadSuccessful}) {\n      rosterLoad {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "14cc6463d6b0e81078fa68042c91fe85";

export default node;
